/**
 * /whois — migrated from public/js/whois.js.
 * Spinner pe submit (pagina GET → revine), hide pe load complete.
 */
import { Resort } from '../core/resort.js';

new Resort((rt) => {
    ($('form.search') as Element | null)?.on('submit', function () {
        rt.showModal();
        rt.showLoader();
    });

    window.addEventListener('load', () => {
        rt.hideModal();
        rt.hideLoader();
    });
});
